import React, { ReactNode } from 'react';
import BreadCrumb, { BreadCrumbItem } from '@/components/bread-crumb';
import cx from 'classnames';
import Loading from '@/components/Loading.Old';
import styles from './index.scss';

interface ArticleContainerProps {
  className?: string | string[];
  breadCrumbClassName?: string;
  breadCrumbItem?: BreadCrumbItem[];
  children?: ReactNode;
  loading?: boolean;
}

const ArticleContainer = (props: ArticleContainerProps) => {
  const {
    className,
    breadCrumbClassName,
    breadCrumbItem,
    children,
    loading = false,
  } = props;
  return (
    <div className={cx(styles.listContainer, className)}>
      {loading ? (
        <Loading backgroundColor={'#fff'} />
      ) : (
        <>
          <div className={breadCrumbClassName}>
            {breadCrumbItem && (
              <BreadCrumb
                className={styles.breadCrumb}
                items={breadCrumbItem}
              />
            )}
          </div>
          {children}
        </>
      )}
    </div>
  );
};

export default ArticleContainer;
